import Router from "next/router";
import styles from "./CookieConsentDescription.module.css";

export default function CookieConsentDescription(): JSX.Element {
  return (
    <div className={styles.container}>
      <span className={styles.bodyText}>
        We use cookies and similar technologies to personalize content,
        customized and measure advertisements, enhance your browsing experience,
        and analyze website traffic. By clicking Accept, you consent to the use
        of cookies as described in our{" "}
      </span>
      <span
        className={styles.linkText}
        role="button"
        tabIndex={0}
        onKeyDown={() => {
          Router.push({ pathname: "/cookies" });
        }}
        onClick={() => {
          Router.push({ pathname: "/cookies" });
        }}
      >
        Cookies Policy
      </span>
      <span className={styles.bodyText}>
        . By clicking Decline, you reject all non-essential cookies.
      </span>
    </div>
  );
}
